<template>
  <SnackbarMultiple
    ref="snackbar"
    top
    right
    dark
    :max-items="10"
    :delay="500"
    :timeout="10000"
  />
  <!--  <SnackbarMultiple ref="snackbar" top right dark :timeout="-1" />-->
</template>

<script>
import SnackbarMultiple from '@/modules/_global/_components/SnackbarMultiple';

export default {
  name: 'Snacks',

  components: {
    SnackbarMultiple
  },

  data: () => ({
    unwatch: null
  }),

  created() {
    this.unwatch = this.$store.watch(
      state => state.planning.snacks,
      () => {
        const snacks = this.$store.state.planning.snacks;

        if (snacks.length) {
          snacks.forEach(item => {
            this.$refs.snackbar.addItem(item);
          });

          this.$store.commit('planning/clearSnacks');
        }
      }
    );
  },

  destroyed() {
    this.unwatch();
  }
};
</script>

<style scoped></style>
